export default function handleEventClick(
  fn = null,
  fnArgs = undefined,
  preventDefaults = true
) {
  return event => {
    if (!!preventDefaults) {
      event.preventDefault();
    }
    if(!!fn && ('function' === typeof fn)) {
      if(undefined === fnArgs) {
        fn();
      } else {
        fn(fnArgs);
      }
    }
  }
}
